<template>
  <div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50px;
      "
    >
      <img
        src="@/assets/back-office/icons/chevron_icon_left.svg"
        alt=""
        width="30px"
        @click="$router.back()"
        style="cursor: pointer"
      />
      <h2 class="text-xs-center">
        Commission Area Detail
      </h2>
      <div></div>
    </div>
    <v-card class="mt-3">
      <v-card-text class="d-flex">
        <display-1
          >Province:
          {{
            commissionlistbyid.commission_area_province
              .commission_area_province_name
          }}
          | District:
          {{
            commissionlistbyid.commission_area_district
              .commission_area_district_name
          }}</display-1
        >
      </v-card-text>
      <v-card class="mx-3 grey grey lighten-3">
        <v-layout row wrap style="padding:20px">
          <v-flex style="text-align:center; padding-left:20px">Name</v-flex>
          <v-flex style="margin-left:40px">Extra Transport(%)</v-flex>
          <v-flex style="margin-left:30px">GP(%)</v-flex>
          <v-flex style="margin-left:40px">Fee Delivery(%)</v-flex>
          <v-flex style="margin-left:40px">Promotion(%)</v-flex>
          <v-flex>Additional Fee(%)</v-flex>
          <v-flex>Guarantee Fee(%)</v-flex>
          <v-flex>Small Order Price(%)</v-flex>
        </v-layout>
      </v-card>
      <v-layout row wrap style="padding:20px">
        <v-flex>Manager</v-flex>

        <v-flex>{{
          commissionlistbyid.commission_area_extra_transport_price
        }}</v-flex>
        <v-flex>{{ commissionlistbyid.commission_area_gp }}</v-flex>
        <v-flex>{{ commissionlistbyid.commission_area_fee_delivery }}</v-flex>
        <v-flex>{{ commissionlistbyid.commission_area_promotion }}</v-flex>
        <v-flex>{{
          commissionlistbyid.commission_area_fee_delivery_differentail
        }}</v-flex>
        <v-flex>{{ commissionlistbyid.commission_area_guarantee_fee }}</v-flex>
        <v-flex>{{ commissionlistbyid.commission_area_small_order_price }}</v-flex>
      </v-layout>
      <v-layout row wrap style="padding:20px">
        <v-flex>Weserve</v-flex>
        <v-flex
          ><p>
            {{
              set_number(
                commissionlistbyid.commission_area_extra_transport_price
              )
            }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{ set_number(commissionlistbyid.commission_area_gp) }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{ set_number(commissionlistbyid.commission_area_fee_delivery) }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{ set_number(commissionlistbyid.commission_area_promotion) }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{
              set_number(
                commissionlistbyid.commission_area_fee_delivery_differentail
              )
            }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{ set_number(commissionlistbyid.commission_area_guarantee_fee) }}
          </p></v-flex
        >
        <v-flex
          ><p>
            {{ set_number(commissionlistbyid.commission_area_small_order_price) }}
          </p></v-flex
        >
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      CommissionById: {},
      headers: [
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "Extra Transport Price(%)",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "GP(%)",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "Fee Delivery",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "Promotion(%)",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "Additional Fee(%)",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
        {
          text: "Small Order Price(%)",
          align: "center",
          sortable: false,
          value: "commission_area_id",
        },
      ],
      isLoading: false,
      filterStatus: 0,
      searchText: "",
      confirmDeleteDialog: false,
      selectedItem: null,
      isDeleteing: false,
    };
  },
  computed: {
    ...mapState({
      commissionlistbyid: (state) => state.fetchCommission.Commissionbyid,
    }),
  },
  methods: {
    ...mapActions({
      getCommissionList: "fetchCommission/fetchManagerCommissionByid",
    }),
    ...mapMutations({
      setCommissionById: "fetchCommission/setCommissionById",
    }),
    set_number(number) {
      return 100 - number;
    },
  },
  async created() {
    this.isLoading = true;
    this.setCommissionById([]);
    await this.getCommissionList({
      manager_id: this.$route.params.commission_id,
    });
    this.isLoading = false;
  },
};
</script>

<style scoped>
.btn-style-1 {
  /* Layout Properties */
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  width: 150px;
  height: 40px;
  /* UI Properties */
  border-radius: 10px;
  /* Font Properties */
  font-weight: bold;
}
.text_table {
  text-align: center;
}
</style>
